module.exports = __webpack_public_path__ + "img/gateway7.c21cf64a.png";